module.exports = __webpack_public_path__ + "static/img/18.958546d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka3/18.jpg
// module id = GDEO
// module chunks = 16